import {
  Button,
  DatePicker,
  Form,
  PageHeader,
  Row,
  Select,
  Breadcrumb,
  Popconfirm,
  Col,
  Input,
  message,
  Spin,
} from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CSVLink } from "react-csv";
import moment from "moment";
import Page from "_components/Page";
import { Auth } from "_helpers";
import { companyService, extraService, stockClassificationService } from "_services";

const Upload = ({ history }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingCustomers, setIsLoadingCustomers] = useState(false);
  const [isLoadingStores, setIsLoadingStores] = useState(false);
  const [isLoadingCustomerAddresses, setIsLoadingCustomerAddresses] =
    useState(false);
  const [isLoadingStoreAddresses, setIsLoadingStoreAddresses] = useState(false);
  const [isLoadingStockClassification, setIsLoadingStockClassification] =
      useState(false);
    const [stockClassifications, setStockClassifications] = useState([]);
  const [uploading, setUpLoading] = useState(false);
  const [storeAddresses, setStoreAddresses] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [customerAddresses, setCustomerAddresses] = useState([]);
  const [selectedcustomer, setSelectedcustomer] = useState(null);
  const [stores, setStores] = useState([]);
  const [base64File, setBase64File] = useState(null);
  const [originalFileName, setOriginalFileName] = useState(null);
  const [error, setError] = useState(null);

  const [form] = Form.useForm();
  const { Option } = Select;
  const { TextArea } = Input;
  const isLoggedInCustomer = () => {
    return Auth.hasRole(Auth.getProfile(), ["CAU"]);
  };

  useEffect(() => {
    getCustomerCompanies();
    getStoreCompanies();
    getStockClassificationSuggestion();
  }, []);

  const getCustomerCompanies = () => {
    setIsLoadingCustomers(true);
    companyService
      .getSuggestion("?companyTypeCodes=OWN,MAF")
      .then((x) => {
        setIsLoadingCustomers(false);
        setCustomers(x.content);
      })
      .catch((errorInfo) => {
        setIsLoadingCustomers(false);
        message.error(`${errorInfo}`);
      });
  };

  const getStoreCompanies = () => {
    setIsLoadingStores(true);
    companyService
      .getSuggestion("?companyTypeCodes=STORE")
      .then((x) => {
        setIsLoadingStores(false);
        setStores(x.content);
      })
      .catch((errorInfo) => {
        setIsLoadingStores(false);
        message.error(`${errorInfo}`);
      });
  };

  const getCustomerAddresses = (companyId) => {
    if (companyId) {
      setCustomerAddresses([]);
      form.resetFields(["customerAddress"]);
      setIsLoadingCustomerAddresses(true);
      companyService
        .getById(companyId)
        .then((x) => {
          setIsLoadingCustomerAddresses(false);
          setCustomerAddresses(x.content.addresses);
        })
        .catch((errorInfo) => {
          setIsLoadingCustomerAddresses(false);
        });
    }
  };

  const getStoreAddresses = (companyId) => {
    if (companyId) {
      setStoreAddresses([]);
      form.resetFields(["storeAddress"]);
      setIsLoadingStoreAddresses(true);
      companyService
        .getById(companyId)
        .then((x) => {
          setIsLoadingStoreAddresses(false);
          setStoreAddresses(x.content.addresses);
        })
        .catch((errorInfo) => {
          setIsLoadingStoreAddresses(false);
        });
    }
  };

   const getStockClassificationSuggestion = () => {
      setIsLoadingStockClassification(true);
      stockClassificationService
        .getSuggestion()
        .then((x) => {
          setIsLoadingStockClassification(false);
          setStockClassifications(x.content);
        })
        .catch((errorInfo) => {
          setIsLoadingStockClassification(false);
          message.error(`${errorInfo}`);
        });
    };
  

  const handleFormSumbit = () => {
    form
      .validateFields()
      .then((values) => {
        setUpLoading(true);
        // const formData = new FormData();
        // formData.append("file", values.file);
        /* let formData = new FormData();
          Object.keys(values).map((item) => {
            formData.append(item, values[item]);
          }); */

        const payload = {
          customerId: values.customer.id,
          storeId: values.store.id,
          storeAddressId: values.storeAddress.id,
          requestDate: moment(values.requestDate).format("YYYY-MM-DD HH:mm:ss"),
          deliverFrom: values.storeAddress.id,
          deliverTo: values.customerAddress.id,
          contactPersonName: values.contactPersonName,
          contactNumber: values.contactNumber,
          base64FileString: base64File,
          originalFileName: originalFileName,
          stockClass: {
            id: values.stockClass?.id
          }
          
        };
        //console.log("PL: ", payload);
        extraService
          .uploadMaterialRequest(payload)
          .then(() => {
            message.success("Successfully uploaded!");
            setUpLoading(false);
            history.push(".");
          })
          .catch((error) => {
            setUpLoading(false);
            setError(error);
          });
      })
      .catch((error) => {
        //message.error(`${error}`);
      });
  };

  const onCancel = () => {
    history.push("/material-requests");
  };

  const onFileChange = (e) => {
    if (e.target.files[0]) {
      setOriginalFileName(e.target.files[0].name);
      let reader = new FileReader();
      reader.onload = function (e) {
        setBase64File(reader.result);
      };
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const getActionButtons = () => {
    let buttons = [];
    buttons.push(
      <Popconfirm
        title="Are you sure to add the changes?"
        onConfirm={handleFormSumbit}
        key="add-confirm"
      >
        <Button key="1" type="primary" htmlType="submit" loading={uploading}>
          Save
        </Button>
      </Popconfirm>
    );
    buttons.push(
      <Button key="cencel" htmlType="button" onClick={onCancel}>
        Cancel
      </Button>
    );

    return buttons;
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/material-requests">Material Request</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Request Upload</Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={getActionButtons()}
      >
        <Page inner error={error}>
          <Spin tip="Loading..." spinning={isLoading}>
            <Form
              layout="vertical"
              form={form}
              name="form-create"
              requiredMark={false}
            >
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    name={["store", "id"]}
                    label="Store"
                    rules={[{ required: true, message: "Store is required" }]}
                  >
                    <Select
                      placeholder="Please select"
                      allowClear
                      onChange={getStoreAddresses}
                      loading={isLoadingStores}
                    >
                      {stores.length > 0 &&
                        stores.map((t) => (
                          <Option value={t.id} key={t.id}>
                            {t.name}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name={["customer", "id"]}
                    label="Customer"
                    rules={[
                      { required: true, message: "Customer is required" },
                    ]}
                  >
                    <Select
                      placeholder="Please select"
                      allowClear
                      onChange={getCustomerAddresses}
                      loading={isLoadingCustomers}
                    >
                      {customers.length > 0 &&
                        customers.map((t) => (
                          <Option value={t.id} key={t.id}>
                            {t.name}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="requestDate"
                    label="Request Date"
                    rules={[
                      { required: true, message: "Request date is required" },
                    ]}
                    initialValue={moment()}
                  >
                    <DatePicker
                      placeholder="Request date"
                      format="YYYY-MM-DD"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                                <Form.Item
                                  name={["stockClass", "id"]}
                                  label="Stock Classification"
                                  rules={[{ required: true, message: "Stock classification is required" }]}
                                >
                                  <Select
                                    placeholder="Please select"
                                    allowClear
                                    // onChange={getMaterialTypesBasedOnClassification}
                                    loading={isLoadingStockClassification}
                                  >
                                    {stockClassifications.length > 0 &&
                                      stockClassifications.map((t) => (
                                        <Option value={t.id} key={t.id}>
                                          {t.name}
                                        </Option>
                                      ))}
                                  </Select>
                                </Form.Item>
                              </Col>
              </Row>
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    name={["storeAddress", "id"]}
                    label="Delivery From"
                    rules={[
                      {
                        required: true,
                        message: "Delivery address is required",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Please select"
                      allowClear
                      loading={isLoadingStoreAddresses}
                    >
                      {storeAddresses.length > 0 &&
                        storeAddresses.map((t) => (
                          <Option value={t.id} key={t.id}>
                            {t.address}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name={["customerAddress", "id"]}
                    label="Deliver To"
                    rules={[
                      { required: true, message: "Delivery from is required" },
                    ]}
                  >
                    <Select
                      placeholder="Please select"
                      allowClear
                      loading={isLoadingCustomerAddresses}
                    >
                      {customerAddresses.length > 0 &&
                        customerAddresses.map((t) => (
                          <Option value={t.id} key={t.id}>
                            {t.address}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item
                    name="contactPersonName"
                    label="Contact Person Name"
                    rules={[
                      {
                        required: true,
                        message: "Contact persion is required",
                      },
                    ]}
                  >
                    <Input placeholder="Contact persion" />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="contactNumber"
                    label="Contact No:"
                    rules={[
                      { required: true, message: "Contact No. is required" },
                    ]}
                  >
                    <Input placeholder="Contact number" />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    name="file"
                    label="Material Request File"
                    rules={[
                      {
                        required: true,
                        message: "Valid excel file is required",
                      },
                    ]}
                    valuePropName="file"
                  >
                    <Input
                      type="file"
                      name="file"
                      onChange={onFileChange}
                      allowClear
                    />
                  </Form.Item>
                </Col>
                <Col span={6} style={{ paddingTop: 40 }}>
                  <>
                    <CSVLink
                      key="1"
                      data={[]}
                      filename={"Sample-Material-Request-File.csv"}
                      headers={[
                        { label: "Item", key: "stockType" },
                        { label: "LOT", key: "lotNumber" },
                        { label: "Qty", key: "qty" },
                        { label: "UOM", key: "uom" },
                        { label: "Rolls/Box", key: "totalItems" },
                      ]}
                    >
                      Sample Upload File
                    </CSVLink>
                  </>
                </Col>
                <Col span={12}>
                  <Form.Item name="remark" label="Remark">
                    <TextArea />
                  </Form.Item>
                </Col>
                
              </Row>
            </Form>
          </Spin>
        </Page>
      </PageHeader>
    </div>
  );
};

export default Upload;
